<div class="message-wrapper" [ngClass]="{ 'user-message': isUserMessage(), 'assistant-message': !isUserMessage() }">
  <div class="message-container">
    <!-- Avatar for assistant messages -->

    <!-- Message content -->
    <div class="message-bubble">
      @if (!isUserMessage()) {
      <div class="avatar-container">
        <div class="avatar" (click)="printData()">
          <img [src]="chatMessage().imgUrl" alt="AI" class="avatar-image" />
        </div>
      </div>
      }

      <!-- Avatar for user messages -->
      @if (isUserMessage()) {
      <div class="avatar-container-right" (click)="printData()">
        <div class="avatar user-avatar">
          <img [src]="chatMessage()?.imgUrl || '/assets/defaults/avatar_user.jpg'" alt="User" class="avatar-image" />
        </div>
      </div>
      } @if (hasMultiMessages()) {
      <dc-message-orchestrator [messages]="multiMessages()" [messageRole]="chatMessage().role"></dc-message-orchestrator>
      } @else {
      <dc-message-orchestrator [messages]="[audioMessage()]" [messageRole]="chatMessage().role"></dc-message-orchestrator>
      }

      <!-- Translation if available -->
      @if (isAssistantMessage() && chatMessage().evaluation?.['text']) {
      <div class="translation">
        <hr class="divider" />
        {{ chatMessage().evaluation?.['text'] }}
      </div>
      } @if (isUserMessage() && chatMessage().evaluation) {
      <div class="translation" style="color: white">
        <hr class="divider" />
        {{ chatMessage().evaluation?.['text'] }}
      </div>

      <div style="position: absolute; bottom: -10px; left: 20px">
        <span>{{ evaluationEmoji() }}</span>
        <span class="pointer" (click)="showEvaluation()"> 🧐 </span>
      </div>

      }
    </div>
  </div>
</div>
